import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import Industries from './components/Industries';
import WhyChooseUs from './components/WhyChooseUs';
import Team from './components/Team';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Services />
      <HowItWorks />
      <Industries />
      <Team />
      <WhyChooseUs />
      <Footer />
    </div>
  );
}

export default App;